var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',{staticClass:"rounded-10 elevation-0"},[_c('v-card-text',[_c('LineChart',{attrs:{"type":"line","data":_vm.historySeries}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }